import React, { Fragment } from 'react';
import Search from '../users/Search';
import Users from '../users/Users';
import Alert from '../layout/Alert';
import { ReactComponent as Logo } from '../../img/search-3.svg';

const Home = () => {
  return (
    <Fragment>
      <div className='container header-search' id='main-search'>
        <div className='row all-center'>
          <div className='col-sm-12'>
            <Logo className='img-fluid header-img-search' />
          </div>
          <Alert />
          <Search />
        </div>
      </div>
      <Users />
    </Fragment>
  );
};

export default Home;
